<script>
  import { onMount, onDestroy, getContext } from "svelte"
  import { addOverlay, removeOverlay, getMap } from "../map"
  import OwnshipMarker from "./ownshipMarker";

  const EARTH_RADIUS_MILES = 3963

	const flightContext = getContext('flight')
	let flight
  let ownship

  let rangeRingLayer
  let redRing
  let yellowRing

  //$: drawRangeRings($ownship, rangeRingLayer)
  $: basicRangeRing($ownship, rangeRingLayer)

  onMount(() => {
    flight = flightContext.get()
		rangeRingLayer = L.layerGroup()
		addOverlay("Ownship Range", rangeRingLayer, flight.overlay);
		ownship = flight.getHandler(OwnshipMarker)
	})
	onDestroy(() => {
		removeOverlay(rangeRingLayer, flight.overlay)
		rangeRingLayer.removeFrom(getMap())
		flight.releaseHandler(OwnshipMarker)
	})

  function basicRangeRing(pos, layer) {
    if (!pos || !layer) return
    if (!redRing) {
      redRing = L.circle(pos, {radius:609.6, color:'red', weight:2, fill:false}).addTo(layer) // 4000ft in m
    } else {
      redRing.setLatLng(pos)
    }
    if (!yellowRing) {
      yellowRing = L.circle(pos, {radius:6500, color:'yellow', weight:1, fill:false}).addTo(layer) // 4000ft in m
    } else {
      yellowRing.setLatLng(pos)
    }
  }
</script>